module.exports = __webpack_public_path__ + "img/ventla-loader.28f21508.gif";